import { OrganType } from '@nkr/enums/organ-type';
import { useAppHookContext } from '@nkr/utils/rest-api';

export const Home = () => {
    const context = useAppHookContext();

    const organ = context != null ? context.app.site.organ : '';
    const organType = context != null ? context.app.site.organType : 0;

    return (
        <div className='container-fluid'>
            <h1>Welcome to the {organType == OrganType.Kidney ? 'NKR' : 'NLR'} admin site!</h1>

            <footer style={{ position: 'fixed', bottom: 0 }}>
                <p>&copy; {new Date().getFullYear()} - Best Match Corporation dba National {organ.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())} Registry. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Home;